import { render, staticRenderFns } from "./RevenueDynamics.vue?vue&type=template&id=a1819938&scoped=true&"
import script from "./RevenueDynamics.vue?vue&type=script&lang=js&"
export * from "./RevenueDynamics.vue?vue&type=script&lang=js&"
import style0 from "./RevenueDynamics.vue?vue&type=style&index=0&id=a1819938&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1819938",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
